import { post, get, put, del, download} from '../../http'

const path = '/api/accountings'

export default {
    index(params){
        return get(`${path}`, params)
    },
    export(params){
        return download(`${path}`, params)
    },
    get(id){
        return get(`${path}/${id}`)
    },
    post(payload){
        return post(`${path}`, payload)
    },
    update(id, payload){
        return put(`${path}/${id}`, payload)
    },
    delete(id){
        return del(`${path}/${id}`)
    },
    submit(id, payload){
        return post(`${path}/${id}/submit`, payload)
    }
}
